module.exports = __webpack_public_path__ + "static/media/logoAsg.2b63298d.png";